export enum MessageTypeEnum {
  SMS = 'SMS',
  MMS = 'MMS',
  ANY = 'ANY'
}
